// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BespokeCRMTabs/index.css
// module id = 3121
// module chunks = 0